// extracted by mini-css-extract-plugin
export var emailBlockLink = "_pp-0";